import { TEST_VERTICAL_PUBLIC_WIDGET } from '../ids';
import { InstallLocation } from '../types';
export const ids = TEST_VERTICAL_PUBLIC_WIDGET;
export const getDefinition = (staticsUrl) => ({
    ...TEST_VERTICAL_PUBLIC_WIDGET,
    method: 'addSection',
    installLocation: InstallLocation.Profile,
    loginMenuTitle: 'Test Public Widget',
    showInLoginMenu: true,
    social: true,
    socialHome: true,
    urlOverride: 'test-public-widget',
    shouldInstallInitially: false,
    page: {
        name: 'Test Public Widget',
        shortDescription: 'Test Public Widget',
        description: 'Test Public Widget',
        iconURL: `${staticsUrl}/assets/images/icons/pricing-plans.png`,
        origin: 'Test Public Widget',
        isNew: true,
        screenshots: [
            `${staticsUrl}/assets/images/my-subscriptions/my-subscriptions.png`,
            `${staticsUrl}/assets/images/my-subscriptions/my-subscriptions-2.png`,
            `${staticsUrl}/assets/images/my-subscriptions/mobile-my-subscriptions.png`,
            `${staticsUrl}/assets/images/my-subscriptions/mobile-my-subscriptions-2.png`,
        ],
    },
});
//# sourceMappingURL=test-vertical-public-widget.js.map